import React from 'react'

import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'

const GeographicLocation = ({ city, state, country, component: Component = 'div', ...rest }) => (
  <Component {...rest}>
    {city}
    {!isEmpty(city) && (!isEmpty(state) || !isEmpty(country)) && ', '}
    {!isEmpty(state) ? state : country}
  </Component>
)

GeographicLocation.propTypes = {
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
  component: PropTypes.string,
}

export default GeographicLocation
